// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes carousel-slide-next {
  from {
    opacity: 0;
    transform: translateX(24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes carousel-slide-prev {
  from {
    opacity: 0;
    transform: translateX(-24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.carousel {
  --divider-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  width: 100%;
  background-color: #f4002c;
  position: relative;
  z-index: 10;
  padding-top: calc(var(--divider-height) * 0.5625);
}
@media (max-width: 991.98px) {
  .carousel {
    padding-top: calc(var(--divider-height) * 0.8625);
  }
}
.carousel::before {
  content: "";
  height: var(--divider-height);
  background-image: url("https://assets.qnordicsgames.com/image/upload/v1/FINKFCCHRISTMAS26/devider-orange.png");
  background-repeat: repeat-x;
  background-size: contain;
  position: absolute;
  top: calc(var(--divider-height) * -0.375);
  left: 0;
  width: 100%;
}

@media (max-width: 600px) {
  .carousel {
    --divider-height: 64px;
  }
  .carousel::before {
    top: calc(var(--divider-height) * -0.175);
    background-size: cover;
    height: 56px;
  }
}
.carousel__header {
  text-align: center;
  padding: 0 16px;
}

.carousel__heading {
  margin: 0;
  font-size: clamp(1.625rem, 2.75vw, 2.5rem);
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.carousel__content {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.carousel__nav--prev {
  margin-left: 1rem;
}

.carousel__nav--next {
  margin-right: 1rem;
}

.carousel__viewport {
  --current-count: 1;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(var(--current-count), minmax(0, 1fr));
  gap: 16px;
  min-height: 220px;
  position: relative;
  overflow: visible;
  z-index: 100;
}

.carousel__viewport--next .carousel__item {
  animation: carousel-slide-next 260ms cubic-bezier(0.22, 0.61, 0.36, 1) both;
}

.carousel__viewport--prev .carousel__item {
  animation: carousel-slide-prev 260ms cubic-bezier(0.22, 0.61, 0.36, 1) both;
}

.carousel__viewport--next .carousel__item:nth-child(2),
.carousel__viewport--prev .carousel__item:nth-child(2) {
  animation-delay: 40ms;
}

.carousel__viewport--next .carousel__item:nth-child(3),
.carousel__viewport--prev .carousel__item:nth-child(3) {
  animation-delay: 80ms;
}

.carousel__viewport--next .carousel__item:nth-child(4),
.carousel__viewport--prev .carousel__item:nth-child(4) {
  animation-delay: 120ms;
}

.carousel__viewport--next .carousel__item:nth-child(5),
.carousel__viewport--prev .carousel__item:nth-child(5) {
  animation-delay: 160ms;
}

.carousel__viewport--next .carousel__item:nth-child(6),
.carousel__viewport--prev .carousel__item:nth-child(6) {
  animation-delay: 200ms;
}

.carousel__item {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.carousel__media {
  position: relative;
  width: 100%;
  padding-top: 62%;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel__media img {
  position: absolute;
  inset: 0;
  object-fit: cover;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.carousel__title {
  font-size: clamp(1rem, 1.4vw, 1.125rem);
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  margin: 0;
}

.carousel__nav {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: transform 160ms ease;
  position: relative;
  z-index: 2;
}

.carousel__nav:hover:not(:disabled),
.carousel__nav:focus-visible:not(:disabled) {
  transform: translateY(-2px);
}

.carousel__nav:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.carousel__nav-icon {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.carousel__status {
  margin-top: 16px;
  text-align: center;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.8);
}

@media (max-width: 1279px) {
  .carousel {
    gap: 20px;
  }
  .carousel__content {
    gap: 12px;
  }
  .carousel__viewport {
    gap: 12px;
  }
}
@media (max-width: 767px) {
  .carousel {
    gap: 16px;
  }
  .carousel__content {
    gap: 8px;
  }
  .carousel__viewport {
    gap: 8px;
    min-height: 260px;
    padding: 0 12px;
  }
  .carousel__item {
    align-items: center;
  }
  .carousel__media {
    transform: scale(0.9);
    transform-origin: center bottom;
    opacity: 0.75;
    filter: saturate(0.9);
    transition: transform 220ms ease, opacity 220ms ease, filter 220ms ease;
  }
  .carousel__item--active {
    z-index: 2;
  }
  .carousel__item--active .carousel__media {
    transform: scale(1);
    opacity: 1;
    filter: none;
  }
  .carousel__nav {
    width: 56px;
    height: 56px;
  }
  .carousel__nav--prev {
    margin-left: 0.5rem;
  }
  .carousel__nav--next {
    margin-right: 0.5rem;
  }
  .carousel__viewport::before,
  .carousel__viewport::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 52%;
    height: 80%;
    max-width: 180px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0;
    pointer-events: none;
    transition: opacity 200ms ease, transform 200ms ease;
    filter: saturate(0.35) brightness(1.05);
  }
  .carousel__viewport::before {
    left: 0;
    transform: translate(-78%, -50%);
    background-image: var(--prev-image);
  }
  .carousel__viewport::after {
    right: 0;
    transform: translate(78%, -50%);
    background-image: var(--next-image);
  }
  .carousel__viewport--has-prev::before {
    opacity: 0.28;
  }
  .carousel__viewport--has-next::after {
    opacity: 0.28;
  }
}
@media (prefers-reduced-motion: reduce) {
  .carousel__nav {
    transition: none;
  }
  .carousel__viewport--next .carousel__item,
  .carousel__viewport--prev .carousel__item {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/campaign/carousel/carousel.component.scss","webpack://./src/assets/styles/colors.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss"],"names":[],"mappings":"AAGA;EACE;IACE,UAAA;IACA,2BAAA;EAFF;EAIA;IACE,UAAA;IACA,wBAAA;EAFF;AACF;AAKA;EACE;IACE,UAAA;IACA,4BAAA;EAHF;EAKA;IACE,UAAA;IACA,wBAAA;EAHF;AACF;AAMA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;EACA,yBC3BS;ED4BT,kBAAA;EACA,WAAA;EACA,iDAAA;AAJF;AE6CI;EFnDJ;IAYM,iDAAA;EAFJ;AACF;AAIE;EACE,WAAA;EACA,6BAAA;EACA,8GAAA;EACA,2BAAA;EACA,wBAAA;EACA,kBAAA;EACA,yCAAA;EACA,OAAA;EACA,WAAA;AAFJ;;AASA;EACE;IACE,sBAAA;EANF;EAOE;IACG,yCAAA;IACA,sBAAA;IACA,YAAA;EALL;AACF;AASA;EACE,kBAAA;EACA,eAAA;AAPF;;AAUA;EACE,SAAA;EACA,0CAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAPF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,kBAAA;AARF;;AAWA;EACE,kBAAA;EACA,OAAA;EACA,aAAA;EACA,mEAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AARF;;AAWA;EACE,2EAAA;AARF;;AAWA;EACE,2EAAA;AARF;;AAWA;;EAEE,qBAAA;AARF;;AAWA;;EAEE,qBAAA;AARF;;AAWA;;EAEE,sBAAA;AARF;;AAWA;;EAEE,sBAAA;AARF;;AAWA;;EAEE,sBAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EAIA,YAAA;EACA,kBAAA;EACA,UAAA;AAXF;;AAcA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,QAAA;EAGA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAdF;;AAiBA;EACE,uCAAA;EACA,gBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,SAAA;AAfF;;AAkBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;AAfF;;AAkBA;;EAEE,2BAAA;AAfF;;AAkBA;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAfF;;AAkBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,+BAAA;AAfF;;AAkBA;EACE;IACE,SAAA;EAfF;EAkBA;IACE,SAAA;EAhBF;EAmBA;IACE,SAAA;EAjBF;AACF;AAoBA;EACE;IACE,SAAA;EAlBF;EAqBA;IACE,QAAA;EAnBF;EAsBA;IACE,QAAA;IACA,iBAAA;IACA,eAAA;EApBF;EAuBA;IACE,mBAAA;EArBF;EAwBA;IACE,qBAAA;IACA,+BAAA;IACA,aAAA;IACA,qBAAA;IACA,uEAAA;EAtBF;EAyBA;IACE,UAAA;EAvBF;EA0BA;IACE,mBAAA;IACA,UAAA;IACA,YAAA;EAxBF;EA2BA;IACE,WAAA;IACA,YAAA;EAzBF;EA4BA;IACE,mBAAA;EA1BF;EA6BA;IACE,oBAAA;EA3BF;EA8BA;;IAEE,WAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;IACA,WAAA;IACA,gBAAA;IACA,wBAAA;IACA,4BAAA;IACA,2BAAA;IACA,UAAA;IACA,oBAAA;IACA,oDAAA;IACA,uCAAA;EA5BF;EA+BA;IACE,OAAA;IACA,gCAAA;IACA,mCAAA;EA7BF;EAgCA;IACE,QAAA;IACA,+BAAA;IACA,mCAAA;EA9BF;EAiCA;IACE,aAAA;EA/BF;EAkCA;IACE,aAAA;EAhCF;AACF;AAmCA;EACE;IACE,gBAAA;EAjCF;EAoCA;;IAEE,eAAA;EAlCF;AACF","sourcesContent":["@use '../../../../assets/styles/colors' as colors;\n@use '../../../../assets/styles/bootstrap-essentials';\n\n@keyframes carousel-slide-next {\n  from {\n    opacity: 0;\n    transform: translateX(24px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes carousel-slide-prev {\n  from {\n    opacity: 0;\n    transform: translateX(-24px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.carousel {\n  --divider-height: 100px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 24px;\n  width: 100%;\n  background-color: colors.$brand-bg;\n  position: relative;\n  z-index: 10;\n  padding-top: calc(var(--divider-height) * 0.5625);\n  @include bootstrap-essentials.media-breakpoint-down(lg) {\n      padding-top: calc(var(--divider-height) * 0.8625);\n\n  }\n  &::before {\n    content: \"\";\n    height: var(--divider-height);\n    background-image: url('https://assets.qnordicsgames.com/image/upload/v1/FINKFCCHRISTMAS26/devider-orange.png');\n    background-repeat: repeat-x;\n    background-size: contain;\n    position: absolute;\n    top: calc(var(--divider-height) * -0.375);\n    left: 0;\n    width: 100%;\n  }\n  // .intro{\n  //   color: #000;\n  // }\n}\n\n@media (max-width: 600px) {\n  .carousel {\n    --divider-height: 64px;\n    &::before{\n       top: calc(var(--divider-height) * -0.175);\n       background-size: cover;\n       height: 56px;\n    }\n  }\n}\n\n.carousel__header {\n  text-align: center;\n  padding: 0 16px;\n}\n\n.carousel__heading {\n  margin: 0;\n  font-size: clamp(1.625rem, 2.75vw, 2.5rem);\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  //color: #000;\n}\n\n.carousel__content {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n}\n\n.carousel__nav--prev {\n  margin-left: 1rem;\n}\n\n.carousel__nav--next {\n  margin-right: 1rem;\n}\n\n.carousel__viewport {\n  --current-count: 1;\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(var(--current-count), minmax(0, 1fr));\n  gap: 16px;\n  min-height: 220px;\n  position: relative;\n  overflow: visible;\n  z-index: 100;\n}\n\n.carousel__viewport--next .carousel__item {\n  animation: carousel-slide-next 260ms cubic-bezier(0.22, 0.61, 0.36, 1) both;\n}\n\n.carousel__viewport--prev .carousel__item {\n  animation: carousel-slide-prev 260ms cubic-bezier(0.22, 0.61, 0.36, 1) both;\n}\n\n.carousel__viewport--next .carousel__item:nth-child(2),\n.carousel__viewport--prev .carousel__item:nth-child(2) {\n  animation-delay: 40ms;\n}\n\n.carousel__viewport--next .carousel__item:nth-child(3),\n.carousel__viewport--prev .carousel__item:nth-child(3) {\n  animation-delay: 80ms;\n}\n\n.carousel__viewport--next .carousel__item:nth-child(4),\n.carousel__viewport--prev .carousel__item:nth-child(4) {\n  animation-delay: 120ms;\n}\n\n.carousel__viewport--next .carousel__item:nth-child(5),\n.carousel__viewport--prev .carousel__item:nth-child(5) {\n  animation-delay: 160ms;\n}\n\n.carousel__viewport--next .carousel__item:nth-child(6),\n.carousel__viewport--prev .carousel__item:nth-child(6) {\n  animation-delay: 200ms;\n}\n\n.carousel__item {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  //border-radius: 16px;\n  //background: rgba(255, 255, 255, 0.08);\n  //box-shadow: 0 18px 32px rgba(0, 0, 0, 0.18);\n  min-width: 0;\n  position: relative;\n  z-index: 1;\n}\n\n.carousel__media {\n  position: relative;\n  width: 100%;\n  padding-top: 62%;\n  border-radius: 12px;\n  overflow: hidden;\n  //background: rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.carousel__media img {\n  position: absolute;\n  inset: 0;\n  // width: 100%;\n  // height: 100%;\n  object-fit: cover;\n  max-width: 100%;\n  height: auto;\n  margin: 0 auto;\n}\n\n.carousel__title {\n  font-size: clamp(1rem, 1.4vw, 1.125rem);\n  font-weight: 600;\n  line-height: 1.3;\n  //color: #000;\n  text-align: center;\n  margin: 0;\n}\n\n.carousel__nav {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  transition: transform 160ms ease;\n  position: relative;\n  z-index: 2;\n}\n\n.carousel__nav:hover:not(:disabled),\n.carousel__nav:focus-visible:not(:disabled) {\n  transform: translateY(-2px);\n}\n\n.carousel__nav:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.carousel__nav-icon {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.carousel__status {\n  margin-top: 16px;\n  text-align: center;\n  font-size: 0.95rem;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n@media (max-width: 1279px) {\n  .carousel {\n    gap: 20px;\n  }\n\n  .carousel__content {\n    gap: 12px;\n  }\n\n  .carousel__viewport {\n    gap: 12px;\n  }\n}\n\n@media (max-width: 767px) {\n  .carousel {\n    gap: 16px;\n  }\n\n  .carousel__content {\n    gap: 8px;\n  }\n\n  .carousel__viewport {\n    gap: 8px;\n    min-height: 260px;\n    padding: 0 12px;\n  }\n\n  .carousel__item {\n    align-items: center;\n  }\n\n  .carousel__media {\n    transform: scale(0.9);\n    transform-origin: center bottom;\n    opacity: 0.75;\n    filter: saturate(0.9);\n    transition: transform 220ms ease, opacity 220ms ease, filter 220ms ease;\n  }\n\n  .carousel__item--active {\n    z-index: 2;\n  }\n\n  .carousel__item--active .carousel__media {\n    transform: scale(1);\n    opacity: 1;\n    filter: none;\n  }\n\n  .carousel__nav {\n    width: 56px;\n    height: 56px;\n  }\n\n  .carousel__nav--prev {\n    margin-left: 0.5rem;\n  }\n\n  .carousel__nav--next {\n    margin-right: 0.5rem;\n  }\n\n  .carousel__viewport::before,\n  .carousel__viewport::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    width: 52%;\n    height: 80%;\n    max-width: 180px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 200ms ease, transform 200ms ease;\n    filter: saturate(0.35) brightness(1.05);\n  }\n\n  .carousel__viewport::before {\n    left: 0;\n    transform: translate(-78%, -50%);\n    background-image: var(--prev-image);\n  }\n\n  .carousel__viewport::after {\n    right: 0;\n    transform: translate(78%, -50%);\n    background-image: var(--next-image);\n  }\n\n  .carousel__viewport--has-prev::before {\n    opacity: 0.28;\n  }\n\n  .carousel__viewport--has-next::after {\n    opacity: 0.28;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel__nav {\n    transition: none;\n  }\n\n  .carousel__viewport--next .carousel__item,\n  .carousel__viewport--prev .carousel__item {\n    animation: none;\n\n  }\n}\n\n@include bootstrap-essentials.media-breakpoint-up(lg) {}\n","$brown: #cca374;\n$green: #00823d;\n$light-brown: #eaedd2;\n$yellow: #ffcc00;\n$red: #e5052a;\n$brand-bg: #f4002c;\n$header-bg: #000000;\n$white: #ffffff;\n$body-text: #ffffff;","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
